<div>
  <span class="dialog-header">
    <h2 matDialogTitle>Device Details</h2>
    <button mat-icon-button type="button" matTooltip="Cancel Add or Edit Device" class="inverse-button-no-border" (click)="onCancelEditingDevice()">
      <mat-icon>close</mat-icon>
    </button>
  </span>
  <mat-dialog-content>
    <form [formGroup]="deviceForm">
      <mat-form-field appearance="outline">
        <mat-label>number</mat-label>
        <input matInput type="text" formControlName="number" pattern="\d*"  maxlength="10" (keypress)="onDeviceNumberInput($event)">
        @if (deviceForm.controls['number'].hasError('required')) {
          <mat-error>Number is required.</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select formControlName="typeId">
          @for (type of data.deviceTypes; track type) {
            <mat-option [value]="type.ID">
              {{type.Name}}
            </mat-option>
          }
        </mat-select>
        @if (deviceForm.controls['typeId'].hasError('required')) {
          <mat-error>Device type is required.</mat-error>
        }
      </mat-form-field>
      <mat-checkbox formControlName="preferred">Preferred</mat-checkbox>
      <mat-checkbox formControlName="visible">Visible</mat-checkbox>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <span class="dialog-cancel-save-buttons-container">
      <button mat-button matTooltip="Save Editing" class="regular-button" (click)="onSavingDevice()" [disabled]="!deviceForm.valid">
        <mat-icon>check</mat-icon>
      </button>
    </span>
  </mat-dialog-actions>
</div>